import { IS_IBG_MANAGER } from "@/consts";
import type { EditorModel } from "@/types";
import Quill from "quill";

export default (force: boolean = false): EditorModel => {
  if (IS_IBG_MANAGER && !force) {
    return "";
  }

  const quill = new Quill(document.createElement("div"));
  return quill.getContents();
};
